import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  NavbarContentRow,
  UserDetailsContainer,
  UserNameContainer,
  UserName,
  UserCompanyName,
  UserProfileImage,
} from './styles';
import { Images } from 'assets/images';

import { useActions } from 'hooks/useActions';
import * as authActions from 'global/actions/authActions';
import { ButtonContainer, HeaderLink } from './styles';
import { FreecodeButton } from 'components/Button/RectangleButton';
import FreecodeAuthModal from 'components/Modals/FreecodeModals/FreecodeAuthModal/FreecodeAuthModal';

export default function UserDetails({ userRedirectUrl }) {
  const navigate = useNavigate();

  const { initialize } = useActions(authActions);

  const { isInitialized, user, userRole, company } = useSelector((state) => state.auth);

  const [displayModal, setDisplayModal] = useState(false);
  const [confirmedNotSignedIn, setConfirmedNotSignedIn] = useState(false);

  const toggleModal = () => {
    initialize(true);
    setDisplayModal(!displayModal);
  };

  useEffect(() => {
    if (!isInitialized) return;
    if (!userRole) return setConfirmedNotSignedIn(true);
    if (!confirmedNotSignedIn) return;
    // Reload the page to get any input from db on sign in
    navigate(0);
  }, [confirmedNotSignedIn, isInitialized, navigate, userRole]);

  const getUserDetails = () => (
    <NavbarContentRow>
      <HeaderLink href={userRedirectUrl}>
        <UserDetailsContainer>
          <UserNameContainer>
            <UserName>{user.name || user.coderCommunityProfile?.name}</UserName>
            {company?.name && <UserCompanyName>{company.name}</UserCompanyName>}
          </UserNameContainer>
          <UserProfileImage
            src={user.avatar?.search('/images') !== 0 ? user.avatar : Images.defaultAvatar}
            alt="profile pic"
          />
        </UserDetailsContainer>
      </HeaderLink>
    </NavbarContentRow>
  );

  const getSignUpButton = () => (
    <ButtonContainer>
      <FreecodeButton marginRight width="max-content" onClick={toggleModal}>
        Sign Up
      </FreecodeButton>
      {displayModal && <FreecodeAuthModal onCancel={toggleModal} />}
    </ButtonContainer>
  );

  return userRole ? getUserDetails() : getSignUpButton();
}
